import { useTranslation } from 'react-i18next';
import { Checkbox } from '@ooh/ui/components/checkbox';

export interface CoCreatorsCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  testId?: string;
}

/**
 * "Dodaj współtwórców" trigger shown on both offer-creation forms
 * (offer-client-collaboration, CU-86cbc2qv8). When checked, the caller opens
 * the existing, unmodified `SharingDialog` against the newly created offer's
 * id right after creation succeeds — this checkbox is the only new UI; no
 * new collaborator-picker is built.
 */
export function CoCreatorsCheckbox({
  checked,
  onCheckedChange,
  disabled = false,
  testId = 'co-creators-checkbox',
}: CoCreatorsCheckboxProps) {
  const { t } = useTranslation('offers');

  return (
    <label
      className="flex items-start gap-3 rounded-lg border border-border/60 bg-muted/20 p-4 text-sm"
      data-testid={`${testId}-field`}
    >
      <Checkbox
        checked={checked}
        onCheckedChange={(value) => onCheckedChange(value === true)}
        disabled={disabled}
        data-testid={testId}
        className="mt-0.5"
      />
      <span>
        <span className="block font-medium">{t('create.coCreators.label')}</span>
        <span className="block text-xs text-muted-foreground">{t('create.coCreators.hint')}</span>
      </span>
    </label>
  );
}
